module.exports = __webpack_public_path__ + "static/media/import.cde4defa.gif";